import React from 'react'
import { useTranslation } from 'react-i18next'
import { OrderContainer, OrderCount, OrderCountByCategory } from './index.styled'
import OrderTotals from './OrderTotals'
import OrderHeader from './OrderHeader'
import OrderProducts from './OrderProducts'
import { countOrderItems, countOrderItemsByCategory } from './helper'

const Order = React.memo(({ order }) => {
	const { t } = useTranslation()
	const countItems = countOrderItems(order)
	const countItemsByCategory = countOrderItemsByCategory(order)

	return (
		<OrderContainer data-testid="order">
			<OrderHeader order={order} />
			<OrderProducts order={order} />
			<OrderTotals order={order} />
			<OrderCountByCategory>{countItemsByCategory}</OrderCountByCategory>
			<OrderCount>{t('Modal.count')}: <span>{countItems}</span></OrderCount>
		</OrderContainer>
	)
})

Order.displayName = 'Order'
export default Order
